import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { Button, message } from 'antd';
import MuiIconButton from 'material-ui/IconButton';
import MuiButton from 'material-ui/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import localForage from 'localforage';

import BizCard from '../../components/UI/BizCard';
import BizInput from '../../components/UI/BizInput';
import BizSelect from '../../components/UI/BizSelect';
import FormFloatingButtons from '../../components/FormFloatingButtons';

import MUTATION from '../../graphql/mutations/leadApprovalSheetMutation.graphql';
import { currencyFormat, newCurrentProposal, amountUnitDetails, natureOfChargeOptions } from '../../utils/globals';

const DeleteFormRowButton = (props) => (
  <MuiIconButton
    aria-label="Delete"
    onClick={props.onClick}
    style={{ width: 30, height: 30 }}
  >
    <DeleteIcon />
  </MuiIconButton>
);
DeleteFormRowButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

const addLasToIds = (arr) => (arr.map((entry) => ({ ...entry, id: `${entry.id}__las` })));
const removeTypename = (arr) => (arr.map((entry) => {
  const { __typename, ...newEntry } = entry;
  return newEntry;
}));

const localForageItemkey = (cid) => (`${cid}_las`);

const initialState = ({ companyName, currentProposal, movableSecurities, immovableSecurities }) => ({
  companyName,
  currentProposal: removeTypename(addLasToIds(currentProposal)),
  movableSecurities: movableSecurities ? removeTypename(addLasToIds(movableSecurities)) : [],
  immovableSecurities: immovableSecurities ? removeTypename(addLasToIds(immovableSecurities)) : [],
  approvalAmount: 0,
  termsOffered: '',
  otherCovenants: '',
  proposedFees: '',
  startedAt: new Date().toISOString(),
});

class LeadApprovalSheetForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initialState(props),
    };
  }

  componentDidMount() {
    localForage.getItem(localForageItemkey(this.props.match.params.cid))
      .then((value) => {
        if (value) {
          this.setState({
            ...value,
          });
        }
      });
  }

  clearForm = () => {
    localForage.removeItem(localForageItemkey(this.props.match.params.cid));
    this.setState({
      ...initialState(this.props),
    });
  };

  saveData = () => {
    const { ...data } = this.state;
    localForage.setItem(localForageItemkey(this.props.match.params.cid), data)
      .then(() => {
        message.success('Saved!');
      })
      .catch(() => {
        message.error('Not Saved!');
      });
  };

  handleFormValue = (key, value) => {
    this.setState({
      [key]: value,
    });
  };

  handleArrayFormValue = (arrayName, id, key, value) => {
    this.setState({
      [arrayName]: this.state[arrayName].map((entry) => {
        if (entry.id === id) {
          return { ...entry, [key]: value };
        }
        return entry;
      }),
    });
  };

  removeFormRow = (stateObjKey, id) => {
    this.setState({
      [stateObjKey]: this.state[stateObjKey].filter((entry) => (entry.id !== id)),
    });
  };

  immovableSecuritiesRow = (entry) => (
    <tr key={entry.id}>
      <td>
        <div>
          <BizInput
            type="textarea"
            theme="lac"
            name={`immovableSecurities[${entry.id}][address]`}
            onChange={(value) => { this.handleArrayFormValue('immovableSecurities', entry.id, 'address', value); }}
            value={entry.address}
            placeholder="Street Address"
          />
        </div>
        <div>
          <BizInput
            theme="lac"
            name={`immovableSecurities[${entry.id}][city]`}
            onChange={(value) => { this.handleArrayFormValue('immovableSecurities', entry.id, 'city', value); }}
            value={entry.city}
            placeholder="City"
          />
        </div>
        <div>
          <BizInput
            theme="lac"
            name={`immovableSecurities[${entry.id}][state]`}
            onChange={(value) => { this.handleArrayFormValue('immovableSecurities', entry.id, 'state', value); }}
            value={entry.state}
            placeholder="State"
          />
        </div>
        <div>
          <BizInput
            theme="lac"
            name={`immovableSecurities[${entry.id}][pincode]`}
            onChange={(value) => { this.handleArrayFormValue('immovableSecurities', entry.id, 'pincode', value); }}
            value={entry.pincode}
            placeholder="Pincode"
          />
        </div>
      </td>
      <td>
        <BizInput
          theme="lac"
          name={`immovableSecurities[${entry.id}][propertyType]`}
          onChange={(value) => { this.handleArrayFormValue('immovableSecurities', entry.id, 'propertyType', value); }}
          value={entry.propertyType}
        />
      </td>
      <td>
        <BizInput
          theme="lac"
          name={`immovableSecurities[${entry.id}][ownedBy]`}
          onChange={(value) => { this.handleArrayFormValue('immovableSecurities', entry.id, 'ownedBy', value); }}
          value={entry.ownedBy}
        />
      </td>
      <td>
        <BizInput
          type="number"
          theme="lac"
          name={`immovableSecurities[${entry.id}][plotArea]`}
          onChange={(value) => { this.handleArrayFormValue('immovableSecurities', entry.id, 'plotArea', value); }}
          value={entry.plotArea}
        />
      </td>
      <td>
        <BizInput
          type="number"
          theme="lac"
          name={`immovableSecurities[${entry.id}][constructionArea]`}
          onChange={(value) => { this.handleArrayFormValue('immovableSecurities', entry.id, 'constructionArea', value); }}
          value={entry.constructionArea}
        />
      </td>
      <td>
        <BizInput
          type="number"
          theme="lac"
          name={`immovableSecurities[${entry.id}][marketValue]`}
          onChange={(value) => { this.handleArrayFormValue('immovableSecurities', entry.id, 'marketValue', value); }}
          value={entry.marketValue}
        />
      </td>
      <td>
        <BizInput
          theme="lac"
          name={`immovableSecurities[${entry.id}][product]`}
          onChange={(value) => { this.handleArrayFormValue('immovableSecurities', entry.id, 'product', value); }}
          value={entry.product}
        />
      </td>
      <td>
        <BizSelect
          name={`immovableSecurities[${entry.id}][chargeNature]`}
          onChange={(value) => { this.handleArrayFormValue('immovableSecurities', entry.id, 'chargeNature', value); }}
          value={entry.chargeNature}
          options={natureOfChargeOptions}
          theme="lac"
        />
      </td>
      <td>
        <DeleteFormRowButton onClick={() => { this.removeFormRow('immovableSecurities', entry.id); }} />
      </td>
    </tr>
  );

  immovableSecurityNewBtn = (type) => (
    <Button
      onClick={() => {
        this.setState({
          immovableSecurities: [...this.state.immovableSecurities, {
            id: (+new Date()).toString(36),
            type,
            address: '',
            city: '',
            state: '',
            pincode: '',
            propertyType: '',
            ownedBy: '',
            plotArea: 0,
            constructionArea: 0,
            marketValue: 0,
            product: '',
            chargeNature: null,
          }],
        });
      }}
    >
      Add new
    </Button>
  );

  movableSecuritiesRow = (entry) => (
    <tr key={entry.id}>
      <td>
        <BizInput
          type="textarea"
          textareaRows={2}
          theme="lac"
          name={`movableSecurities[${entry.id}][details]`}
          onChange={(value) => { this.handleArrayFormValue('movableSecurities', entry.id, 'details', value); }}
          value={entry.details}
        />
      </td>
      <td>
        <BizInput
          type="number"
          theme="lac"
          name={`movableSecurities[${entry.id}][marketValue]`}
          onChange={(value) => { this.handleArrayFormValue('movableSecurities', entry.id, 'marketValue', value); }}
          value={entry.marketValue}
        />
      </td>
      <td>
        <BizInput
          theme="lac"
          name={`movableSecurities[${entry.id}][product]`}
          onChange={(value) => { this.handleArrayFormValue('movableSecurities', entry.id, 'product', value); }}
          value={entry.product}
        />
      </td>
      <td>
        <BizSelect
          name={`movableSecurities[${entry.id}][chargeNature]`}
          onChange={(value) => { this.handleArrayFormValue('movableSecurities', entry.id, 'chargeNature', value); }}
          value={entry.chargeNature}
          options={natureOfChargeOptions}
          theme="lac"
        />
      </td>
      <td>
        <DeleteFormRowButton onClick={() => { this.removeFormRow('movableSecurities', entry.id); }} />
      </td>
    </tr>
  );

  movableSecuritiesNewBtn = (type) => (
    <Button
      onClick={() => {
        this.setState({
          movableSecurities: [...this.state.movableSecurities, {
            id: (+new Date()).toString(36),
            type,
            details: '',
            marketValue: 0,
            product: '',
            chargeNature: null,
          }],
        });
      }}
    >
      Add new
    </Button>
  );

  handleFormSubmit = () => {
    const customerId = this.props.match.params.cid;

    this.props.mutate({
      variables: {
        customerId,
        ...this.state,
      },
    })
      .then(() => {
        message.success('Success!');
        this.clearForm();
        // this.props.history.push(`/app/lead/${customerId}`);
      })
      .catch((mutateErr) => {
        message.error(mutateErr.message);
      });
  };

  render() {
    const {
      companyName,
      currentProposal,
      movableSecurities,
      immovableSecurities,
      approvalAmount,
      termsOffered,
      otherCovenants,
      proposedFees,
    } = this.state;

    const { amountUnit, match } = this.props;

    return (
      <BizCard title="Lead Approval Sheet">
        <FormFloatingButtons handleSave={this.saveData} handleClear={this.clearForm} />
        <table className="biz-form-table">
          <tbody>
            {/* Company Name */}
            <tr>
              <td className="biz-form-table-label">Company Name</td>
              <td className="biz-form-table-input">
                <BizInput name="companyName" theme="lac" onChange={(value) => { this.setState({ companyName: value }); }} value={companyName} />
              </td>
              <td className="biz-form-table-action" />
            </tr>

            {/* Current Proposal */}
            <tr>
              <td className="biz-form-table-label">Current Proposal</td>
              <td className="biz-form-table-input">
                {
                  currentProposal.length > 0 ?
                    <div>
                      <p>The unit of amount is - {amountUnitDetails[amountUnit].name}</p>
                      <table className="biz-data-table">
                        <thead>
                          <tr>
                            <th>Remark</th>
                            <th>CC</th>
                            <th>TL</th>
                            <th>LC</th>
                            <th>BG</th>
                            <th>Other</th>
                            <th>Total</th>
                            <th />
                          </tr>
                        </thead>
                        <tbody>
                          {
                            currentProposal.map((entry) => (
                              <tr key={entry.id}>
                                <td style={{ minWidth: 200 }}>
                                  <BizInput
                                    theme="lac"
                                    name={`currentProposal[${entry.id}][remark]`}
                                    onChange={(value) => { this.handleArrayFormValue('currentProposal', entry.id, 'remark', value); }}
                                    value={entry.remark}
                                  />
                                </td>
                                <td>
                                  <BizInput
                                    type="number"
                                    theme="lac"
                                    name={`currentProposal[${entry.id}][cc]`}
                                    onChange={(value) => { this.handleArrayFormValue('currentProposal', entry.id, 'cc', value); }}
                                    value={entry.cc}
                                  />
                                </td>
                                <td>
                                  <BizInput
                                    type="number"
                                    theme="lac"
                                    name={`currentProposal[${entry.id}][tl]`}
                                    onChange={(value) => { this.handleArrayFormValue('currentProposal', entry.id, 'tl', value); }}
                                    value={entry.tl}
                                  />
                                </td>
                                <td>
                                  <BizInput
                                    type="number"
                                    theme="lac"
                                    name={`currentProposal[${entry.id}][lc]`}
                                    onChange={(value) => { this.handleArrayFormValue('currentProposal', entry.id, 'lc', value); }}
                                    value={entry.lc}
                                  />
                                </td>
                                <td>
                                  <BizInput
                                    type="number"
                                    theme="lac"
                                    name={`currentProposal[${entry.id}][bg]`}
                                    onChange={(value) => { this.handleArrayFormValue('currentProposal', entry.id, 'bg', value); }}
                                    value={entry.bg}
                                  />
                                </td>
                                <td>
                                  <BizInput
                                    type="number"
                                    theme="lac"
                                    name={`currentProposal[${entry.id}][other]`}
                                    onChange={(value) => { this.handleArrayFormValue('currentProposal', entry.id, 'other', value); }}
                                    value={entry.other}
                                  />
                                </td>
                                <td>
                                  {currencyFormat(entry.tl + entry.cc + entry.bg + entry.lc + entry.other)} {amountUnitDetails[amountUnit].symbol}
                                </td>
                                <td>
                                  <DeleteFormRowButton onClick={() => { this.removeFormRow('currentProposal', entry.id); }} />
                                </td>
                              </tr>
                            ))
                          }
                        </tbody>
                      </table>
                    </div>
                    :
                    null
                }
              </td>
              <td className="biz-form-table-action">
                <Button
                  onClick={() => {
                    const newProposal = newCurrentProposal();
                    newProposal.id = `${newProposal.id}__las`;
                    this.setState({
                      currentProposal: [...currentProposal, newProposal],
                    });
                  }}
                >
                  Add new proposal
                </Button>
              </td>
            </tr>

            {/* Primary Immovable Security */}
            <tr>
              <td className="biz-form-table-label">Primary Immovable Security</td>
              <td className="biz-form-table-input">
                <table className="biz-data-table biz-bordered">
                  <thead>
                    <tr>
                      <th>Address</th>
                      <th>Property Type</th>
                      <th>Owned By</th>
                      <th>Plot Area</th>
                      <th>Construction Area</th>
                      <th>Market Value</th>
                      <th>Product</th>
                      <th>Nature of Charge</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    {
                      immovableSecurities.filter((element) => (element.type === 'primary')).map((entry) => (
                        this.immovableSecuritiesRow(entry)
                      ))
                    }
                  </tbody>
                </table>
              </td>
              <td className="biz-form-table-action">
                {
                  this.immovableSecurityNewBtn('primary')
                }
              </td>
            </tr>

            {/* Collateral Immovable Security */}
            <tr>
              <td className="biz-form-table-label">Collateral Immovable Security</td>
              <td className="biz-form-table-input">
                <table className="biz-data-table biz-bordered">
                  <thead>
                    <tr>
                      <th>Address</th>
                      <th>Property Type</th>
                      <th>Owned By</th>
                      <th>Plot Area</th>
                      <th>Construction Area</th>
                      <th>Market Value</th>
                      <th>Product</th>
                      <th>Nature of Charge</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    {
                      immovableSecurities.filter((element) => (element.type === 'collateral')).map((entry) => (
                        this.immovableSecuritiesRow(entry)
                      ))
                    }
                  </tbody>
                </table>
              </td>
              <td className="biz-form-table-action">
                {
                  this.immovableSecurityNewBtn('collateral')
                }
              </td>
            </tr>

            {/* Primary - Movable */}
            <tr>
              <td className="biz-form-table-label">Primary Movable Security</td>
              <td className="biz-form-table-input">
                <table className="biz-data-table biz-bordered">
                  <thead>
                    <tr>
                      <th>Particulars</th>
                      <th>Market Value</th>
                      <th>Product</th>
                      <th>Nature of Charge</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    {
                      movableSecurities.filter((element) => (element.type === 'primary')).map((entry) => (
                        this.movableSecuritiesRow(entry)
                      ))
                    }
                  </tbody>
                </table>
              </td>
              <td className="biz-form-table-action">
                {
                  this.movableSecuritiesNewBtn('primary')
                }
              </td>
            </tr>

            {/* Collateral - Movable */}
            <tr>
              <td className="biz-form-table-label">Collateral Movable Security</td>
              <td className="biz-form-table-input">
                <table className="biz-data-table biz-bordered">
                  <thead>
                    <tr>
                      <th>Particulars</th>
                      <th>Market Value</th>
                      <th>Product</th>
                      <th>Nature of Charge</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    {
                      movableSecurities.filter((element) => (element.type === 'collateral')).map((entry) => (
                        this.movableSecuritiesRow(entry)
                      ))
                    }
                  </tbody>
                </table>
              </td>
              <td className="biz-form-table-action">
                {
                  this.movableSecuritiesNewBtn('collateral')
                }
              </td>
            </tr>

            {/* Approval Amount */}
            <tr>
              <td className="biz-form-table-label">Approval Amount</td>
              <td className="biz-form-table-input">
                <BizInput
                  type="number"
                  theme="lac"
                  name="approvalAmount"
                  onChange={(value) => { this.handleFormValue('approvalAmount', value); }}
                  value={approvalAmount}
                />
              </td>
              <td className="biz-form-table-action" />
            </tr>

            {/* Terms Offered by Bizminder */}
            <tr>
              <td className="biz-form-table-label">Terms Offered by Bizminder</td>
              <td className="biz-form-table-input">
                <BizInput
                  type="textarea"
                  theme="lac"
                  name="termsOffered"
                  onChange={(value) => { this.handleFormValue('termsOffered', value); }}
                  value={termsOffered}
                  style={{ width: '100%', height: 200, maxWidth: 'unset' }}
                />
              </td>
              <td className="biz-form-table-action" />
            </tr>

            {/* Other Covenants */}
            <tr>
              <td className="biz-form-table-label">Other Covenants</td>
              <td className="biz-form-table-input">
                <BizInput
                  type="textarea"
                  theme="lac"
                  name="otherCovenants"
                  onChange={(value) => { this.handleFormValue('otherCovenants', value); }}
                  value={otherCovenants}
                  style={{ width: '100%', height: 200, maxWidth: 'unset' }}
                />
              </td>
              <td className="biz-form-table-action" />
            </tr>

            {/* Proposed Fees */}
            <tr>
              <td className="biz-form-table-label">Proposed Fees</td>
              <td className="biz-form-table-input">
                <BizInput
                  theme="lac"
                  name="proposedFees"
                  onChange={(value) => { this.handleFormValue('proposedFees', value); }}
                  value={proposedFees}
                />
              </td>
              <td className="biz-form-table-action" />
            </tr>

            <tr>
              <td className="biz-form-table-label" />
              <td colSpan={2}>
                <MuiButton variant="raised" color="primary" style={{ margin: '5px 0' }} onClick={this.handleFormSubmit}>
                  Submit
                </MuiButton>
              </td>
            </tr>

          </tbody>
        </table>
      </BizCard>
    );
  }
}

LeadApprovalSheetForm.propTypes = {
  companyName: PropTypes.string.isRequired,
  currentProposal: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
  })).isRequired,
  movableSecurities: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
  })),
  immovableSecurities: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
  })),
  amountUnit: PropTypes.string.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      cid: PropTypes.string.isRequired,
    }),
  }).isRequired,
  mutate: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

LeadApprovalSheetForm.defaultProps = {
  movableSecurities: null,
  immovableSecurities: null,
};

export default graphql(MUTATION)(LeadApprovalSheetForm);



// WEBPACK FOOTER //
// ./src/pages/leads/LeadApprovalSheetForm.jsx